export default __webpack_public_path__ + "static/media/YAS0250.34I-29711_-17165_0.db81c3b4.jpg";